import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const GLOBAL_FOOTER_EMAIL_I18N_NAMESPACE =
  '@mc/next/components/FooterEmailCapture'

export const i18nInstance = registerI18nResources({
  namespace: GLOBAL_FOOTER_EMAIL_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
